module.exports = __webpack_public_path__ + "static/img/2_07.00001603.jpg";